/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Paymentmethods1Inputs */

const en__field_paymentmethods1 = /** @type {(inputs: _Field_Paymentmethods1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`payment methods`)
};

const de__field_paymentmethods1 = /** @type {(inputs: _Field_Paymentmethods1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsmethoden`)
};

/**
* | output |
* | --- |
* | "payment methods" |
*
* @param {_Field_Paymentmethods1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_paymentmethods1 = /** @type {((inputs?: _Field_Paymentmethods1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Paymentmethods1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_paymentmethods1(inputs)
	return de__field_paymentmethods1(inputs)
});
export { _field_paymentmethods1 as "_field_paymentMethods" }